/* Welltoe storefront scripts: gallery, bundle buy box, sticky bar, gift sync, cart drawer extras, reviews wall. */
(function () {
  if (window.Welltoe) return;

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    format = format || (window.Shopify && Shopify.money_format) || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function withDelimiters(num, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (num / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(cents, 0);
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2);
      }
    });
  }

  /* Prices may carry HTML from the store's money format (e.g. <span class=money> for currency apps like BUCKS).
     Render that markup instead of showing it as text. */
  function setMoney(el, str) {
    if (!el) return;
    str = String(str == null ? '' : str);
    if (str.indexOf('<') === -1) { el.textContent = str; return; }
    var tpl = document.createElement('template');
    tpl.innerHTML = str;
    tpl.content.querySelectorAll('script,style,iframe,object,embed').forEach(function (n) { n.remove(); });
    tpl.content.querySelectorAll('*').forEach(function (n) {
      Array.prototype.slice.call(n.attributes).forEach(function (a) { if (/^on/i.test(a.name)) n.removeAttribute(a.name); });
    });
    el.replaceChildren(tpl.content);
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function jsonFetch(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(root() + url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || 'Something went wrong');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { return ['cart-drawer', 'cart-icon-bubble']; }

  function renderDrawer(sections) {
    var drawer = cartDrawer();
    if (!drawer) { window.location.href = root() + 'cart'; return; }
    if (sections) {
      /* Keep Dawn's "is-empty" flag in step with the new contents: off when there are items
         (the first add doesn't come through Dawn's own form), on when the cart is now empty. */
      var empty = isEmptyDrawerHtml(sections['cart-drawer']);
      /* Remember where the shopper was scrolled (and which color box they used), so the drawer
         doesn't jump back to the top every time it reloads after a change. */
      var keep = drawerScrollState(drawer);
      drawer.classList.toggle('is-empty', empty);
      drawer.renderContents({ sections: sections });
      /* Keep the "Your colors" list open if the shopper had it open. */
      var colors = document.querySelector('[data-wt-colors]');
      if (colors && colorsOpen) colors.open = true;
      applyPairOrder();
      restoreDrawerScroll(drawer, keep);
      /* Cart just became empty: close the drawer instead of leaving a blank panel open. */
      if (empty) setTimeout(function () { drawer.close(); }, 60);
    }
    else drawer.open();
  }

  function drawerScrollers(drawer) {
    return [drawer.querySelector('cart-drawer-items'), drawer.querySelector('.drawer__inner')].filter(Boolean);
  }
  function drawerScrollState(drawer) {
    var active = document.activeElement;
    return {
      tops: drawerScrollers(drawer).map(function (el) { return el.scrollTop; }),
      focusId: active && active.id && drawer.contains(active) ? active.id : null
    };
  }
  function restoreDrawerScroll(drawer, keep) {
    function apply() {
      drawerScrollers(drawer).forEach(function (el, i) { if (keep.tops[i]) el.scrollTop = keep.tops[i]; });
      if (keep.focusId) {
        var el = document.getElementById(keep.focusId);
        if (el && document.activeElement !== el) { try { el.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
      }
    }
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 60);
  }

  /* ---------- Stable pair order in the cart's color list ----------
     Shopify stores a recolored pair as a new cart line, which would move it in the list.
     We remember the order the shopper sees (paid/free + color per pair) and put every pair back
     in its spot after each change, so "Pair 1" stays Pair 1. New paid pairs go after the paid ones. */
  var PAIR_ORDER_KEY = 'wt_pair_order';
  var pairOrderMem = null;
  function loadPairOrder() {
    if (pairOrderMem) return pairOrderMem;
    try { return JSON.parse(window.sessionStorage.getItem(PAIR_ORDER_KEY)) || []; } catch (e) { return []; }
  }
  function savePairOrder(order) {
    pairOrderMem = order;
    try { window.sessionStorage.setItem(PAIR_ORDER_KEY, JSON.stringify(order)); } catch (e) { /* ignore */ }
  }
  function pairUnitKey(sel) { return (sel.dataset.free === 'true' ? 'f' : 'p') + ':' + sel.dataset.current; }
  function applyPairOrder() {
    var grid = document.querySelector('.wt-pcard__grid');
    if (!grid) return;
    var pool = Array.prototype.map.call(grid.querySelectorAll('.wt-pcard__pair'), function (el) {
      var sel = el.querySelector('[data-wt-recolor-select]');
      return { el: el, k: sel ? pairUnitKey(sel) : '' };
    });
    var ordered = [];
    loadPairOrder().forEach(function (k) {
      for (var i = 0; i < pool.length; i++) {
        if (pool[i].k === k) { ordered.push(pool[i]); pool.splice(i, 1); return; }
      }
    });
    pool.forEach(function (u) {
      if (u.k.charAt(0) === 'p') {
        var firstFree = -1;
        for (var i = 0; i < ordered.length; i++) { if (ordered[i].k.charAt(0) === 'f') { firstFree = i; break; } }
        if (firstFree < 0) ordered.push(u); else ordered.splice(firstFree, 0, u);
      } else {
        ordered.push(u);
      }
    });
    ordered.forEach(function (u, i) {
      grid.appendChild(u.el);
      var no = u.el.querySelector('[data-wt-pair-no]');
      if (no) no.textContent = i + 1;
    });
    grid.setAttribute('data-wt-ordered', '');
    savePairOrder(ordered.map(function (u) { return u.k; }));
  }
  /* Before a color change is sent, record the new color in the pair's own spot. */
  function notePairRecolor(sel, newVariantId) {
    var grid = sel.closest('.wt-pcard__grid');
    if (!grid) return;
    var pairs = Array.prototype.slice.call(grid.querySelectorAll('.wt-pcard__pair'));
    var idx = pairs.indexOf(sel.closest('.wt-pcard__pair'));
    if (idx < 0) return;
    var order = pairs.map(function (el) {
      var s = el.querySelector('[data-wt-recolor-select]');
      return s ? pairUnitKey(s) : '';
    });
    order[idx] = (sel.dataset.free === 'true' ? 'f' : 'p') + ':' + newVariantId;
    savePairOrder(order);
  }
  /* Also re-order after the theme's own cart updates redraw the drawer. */
  function watchPairGrid() {
    var drawer = cartDrawer();
    if (!drawer || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      var grid = document.querySelector('.wt-pcard__grid');
      if (!grid || grid.hasAttribute('data-wt-ordered')) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; applyPairOrder(); });
    }).observe(drawer, { childList: true, subtree: true });
  }

  var colorsOpen = false;
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-wt-colors]')) colorsOpen = e.target.open;
  }, true);

  function isEmptyDrawerHtml(html) {
    return typeof html === 'string' && html.indexOf('drawer__inner-empty') > -1;
  }

  function closeDrawerIfEmpty(itemCount) {
    var drawer = cartDrawer();
    if (!drawer || itemCount !== 0) return;
    drawer.classList.add('is-empty');
    setTimeout(function () { drawer.close(); }, 60);
  }

  function refreshSections() {
    return fetch(root() + '?sections=' + sectionIds().join(','))
      .then(function (r) { return r.json(); });
  }

  /* ---------- gift sync ---------- */
  var giftCfg = null;
  function readGiftConfig() {
    if (giftCfg) return giftCfg;
    var el = document.getElementById('wt-gift-config');
    try { giftCfg = el ? JSON.parse(el.textContent) : null; } catch (e) { giftCfg = null; }
    /* Free-pair settings live in the cart drawer file (wt-free-config). */
    var fe = document.getElementById('wt-free-config');
    if (fe) {
      try {
        var fc = JSON.parse(fe.textContent);
        giftCfg = giftCfg || { auto: false, t2: 3, t3: 5 };
        if (!giftCfg.productId && fc.productId) giftCfg.productId = fc.productId;
        giftCfg.freeProductId = fc.freeProductId;
        giftCfg.freeMap = fc.freeMap || {};
      } catch (e) { /* ignore */ }
    }
    return giftCfg;
  }

  function readPaidConfig() {
    var el = document.getElementById('wt-cart-config');
    var c = {};
    try { c = el ? JSON.parse(el.textContent) : {}; } catch (e) { c = {}; }
    var g = readGiftConfig() || {};
    var t2q = g.t2 || 3, t3q = g.t3 || 5;
    var t2p = c.t2Paid || 2, t3p = c.t3Paid || 3;
    return { t2Paid: t2p, t3Paid: t3p, t2Free: Math.max(0, t2q - t2p), t3Free: Math.max(0, t3q - t3p) };
  }

  /* Free pairs for a paid count. The offer repeats: every 3 paid = 2 free, and a leftover 2 paid = 1 free.
     1 -> 0, 2 -> 1, 3 -> 2, 4 -> 2, 5 -> 3, 6 -> 4, 7 -> 4 ... */
  function freeFor(paid, pc) {
    var groups = Math.floor(paid / pc.t3Paid);
    var rest = paid % pc.t3Paid;
    return groups * pc.t3Free + (rest >= pc.t2Paid ? pc.t2Free : 0);
  }

  /* Keeps the cart matching the offer, counted in PAID pairs:
     free pairs follow freeFor() · gifts stack the same way (each Buy 3 Get 2 = gift 1 + gift 2, a leftover Buy 2 Get 1 = gift 1).
     Free pairs are lines of the hidden $0 "free pair" product (same color), marked with the hidden _wt_free property. */
  var syncing = false;
  function syncGifts() {
    var cfg = readGiftConfig();
    if (!cfg || syncing) return Promise.resolve(false);
    var pc = readPaidConfig();
    syncing = true;
    return jsonFetch('cart.js').then(function (cart) {
      var giftIds = [cfg.gift1, cfg.gift2].filter(Boolean);
      var fmap = cfg.freeMap || {};
      var useFreeProduct = !!(cfg.freeProductId && Object.keys(fmap).length);
      var anyFree = null;
      Object.keys(fmap).forEach(function (k) { if (!anyFree) anyFree = fmap[k]; });
      function freeVariantFor(vid) { return useFreeProduct ? (fmap[String(vid)] || anyFree) : vid; }
      var paid = 0, firstPaidVariant = null;
      var giftLines = {}, freeLines = [], oldFreeLines = [];
      cart.items.forEach(function (item) {
        var props = item.properties || {};
        if (giftIds.indexOf(item.variant_id) > -1 || props._wt_gift) {
          (giftLines[item.variant_id] = giftLines[item.variant_id] || []).push(item);
          return;
        }
        /* Free pairs are the hidden $0 "free pair" product, so checkout shows them at $0 with no discount needed. */
        if (useFreeProduct && item.product_id === cfg.freeProductId) { freeLines.push(item); return; }
        if (cfg.productId && item.product_id !== cfg.productId) return;
        if (props._wt_free) {
          if (useFreeProduct) oldFreeLines.push(item); else freeLines.push(item);
          return;
        }
        paid += item.quantity;
        if (!firstPaidVariant) firstPaidVariant = item.variant_id;
      });

      var updates = {}, toAdd = [];

      /* Old-style free pairs (full-price socks marked free) are swapped for the $0 free pair in the same color. */
      var slots = freeLines.map(function (l) { return { line: l, qty: l.quantity }; });
      oldFreeLines.forEach(function (l) {
        updates[l.key] = 0;
        var add = { id: freeVariantFor(l.variant_id), quantity: l.quantity, properties: { _wt_free: 'Free pair' } };
        toAdd.push(add);
        slots.push({ add: add, qty: l.quantity });
      });

      /* free pairs */
      var freeWant = freeFor(paid, pc);
      var freeHave = slots.reduce(function (n, sl) { return n + sl.qty; }, 0);
      if (freeWant > freeHave) {
        var more = freeWant - freeHave;
        if (slots.length === 0) {
          if (firstPaidVariant) toAdd.push({ id: freeVariantFor(firstPaidVariant), quantity: more, properties: { _wt_free: 'Free pair' } });
        } else {
          var lastSlot = slots[slots.length - 1];
          if (lastSlot.line) updates[lastSlot.line.key] = lastSlot.qty + more; else lastSlot.add.quantity += more;
        }
      } else if (freeWant < freeHave) {
        /* Trim from the last free line first so the colors the shopper picked first stay. */
        var extra = freeHave - freeWant;
        for (var j = slots.length - 1; j >= 0 && extra > 0; j--) {
          var cut = Math.min(slots[j].qty, extra);
          if (slots[j].line) updates[slots[j].line.key] = slots[j].qty - cut; else slots[j].add.quantity -= cut;
          extra -= cut;
        }
      }
      toAdd = toAdd.filter(function (a) { return a.quantity > 0; });

      /* gifts */
      if (cfg.auto) {
        var want = {};
        /* Gifts stack like the free pairs: every Buy 3 Get 2 = 1 of each gift, a leftover Buy 2 Get 1 = 1 more gift 1. */
        var gGroups = Math.floor(paid / pc.t3Paid);
        var gRest = paid % pc.t3Paid;
        if (cfg.gift1) want[cfg.gift1] = gGroups + (gRest >= pc.t2Paid ? 1 : 0);
        if (cfg.gift2) want[cfg.gift2] = (want[cfg.gift2] || 0) + gGroups;
        Object.keys(want).forEach(function (vid) {
          var lines = giftLines[vid] || [];
          var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
          if (have === want[vid]) return;
          if (lines.length === 0) {
            if (want[vid] > 0) toAdd.push({ id: Number(vid), quantity: want[vid], properties: { _wt_gift: 'Free gift' } });
            return;
          }
          lines.forEach(function (l, i) { updates[l.key] = i === 0 ? want[vid] : 0; });
        });
      }

      var chain = Promise.resolve(null);
      if (Object.keys(updates).length) {
        chain = chain.then(function () { return jsonFetch('cart/update.js', { updates: updates, sections: sectionIds() }); });
      }
      if (toAdd.length) {
        chain = chain.then(function () { return jsonFetch('cart/add.js', { items: toAdd, sections: sectionIds() }); });
      }
      return chain.then(function (res) { syncing = false; return res ? res.sections || true : false; });
    }).catch(function (e) { syncing = false; console.warn('[Welltoe] cart sync', e); return false; });
  }

  /* ---------- cart add ---------- */
  function addToCart(items) {
    return jsonFetch('cart/add.js', { items: items, sections: sectionIds() }).then(function (res) {
      return syncGifts().then(function (synced) {
        var sections = synced && synced !== true ? synced : res.sections;
        if (synced === true) return refreshSections().then(renderDrawer);
        renderDrawer(sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'welltoe', cartData: res });
        }
      });
    });
  }

  /* ---------- Gallery ---------- */
  class WtGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-wt-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.wt-gallery__slide'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-wt-thumb]'));
      this.current = 0;
      var self = this;
      var prev = this.querySelector('[data-wt-prev]');
      var next = this.querySelector('[data-wt-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.current - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.current + 1); });
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.go(Number(t.dataset.wtThumb)); });
      });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.current + 1); }
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          var i = Math.round(self.track.scrollLeft / w);
          if (i !== self.current) self.setActive(i);
        });
      }, { passive: true });

      this.lightbox = this.querySelector('[data-wt-lightbox]');
      if (this.lightbox) this.initLightbox();
      document.addEventListener('wt:variant', function (e) {
        if (!e.detail || !e.detail.media) return;
        var idx = self.slides.findIndex(function (s) { return Number(s.dataset.mediaId) === e.detail.media; });
        if (idx > -1) self.go(idx);
      });
    }
    go(i) {
      var n = this.slides.length;
      if (!n) return;
      i = (i + n) % n;
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.setActive(i);
    }
    setActive(i) {
      this.current = i;
      var counter = this.querySelector('[data-wt-current]');
      if (counter) counter.textContent = i + 1;
      this.thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        if (k === i) {
          var bar = t.parentElement;
          var left = t.offsetLeft - bar.clientWidth / 2 + t.clientWidth / 2;
          bar.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
    }
    initLightbox() {
      var self = this;
      var lb = this.lightbox;
      this.lbImgs = Array.prototype.slice.call(lb.querySelectorAll('[data-lb-index]'));
      this.querySelectorAll('[data-wt-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { self.openLb(Number(b.dataset.wtZoom)); });
      });
      lb.querySelector('[data-wt-lb-close]').addEventListener('click', function () { self.closeLb(); });
      lb.querySelector('[data-wt-lb-prev]').addEventListener('click', function () { self.stepLb(-1); });
      lb.querySelector('[data-wt-lb-next]').addEventListener('click', function () { self.stepLb(1); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') self.stepLb(-1);
        if (e.key === 'ArrowRight') self.stepLb(1);
      });
      lb.addEventListener('close', function () { document.body.classList.remove('wt-no-scroll'); });
      this.lbImgs.forEach(function (img) {
        img.addEventListener('click', function (e) {
          var zoomed = img.classList.toggle('is-zoomed');
          if (zoomed) {
            var r = img.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          }
        });
        img.addEventListener('mousemove', function (e) {
          if (!img.classList.contains('is-zoomed') || e.pointerType === 'touch') return;
          var r = img.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
      });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        var zoomed = lb.querySelector('.is-zoomed');
        if (!zoomed && Math.abs(dx) > 50) self.stepLb(dx < 0 ? 1 : -1);
        sx = null;
      });
    }
    openLb(mediaIndex) {
      var pos = this.lbImgs.findIndex(function (img) { return Number(img.dataset.lbIndex) === mediaIndex; });
      this.lbPos = pos < 0 ? 0 : pos;
      this.showLb();
      if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
      else this.lightbox.setAttribute('open', '');
      document.body.classList.add('wt-no-scroll');
    }
    closeLb() {
      if (typeof this.lightbox.close === 'function') this.lightbox.close();
      else this.lightbox.removeAttribute('open');
      document.body.classList.remove('wt-no-scroll');
    }
    stepLb(d) {
      var n = this.lbImgs.length;
      this.lbPos = (this.lbPos + d + n) % n;
      this.showLb();
    }
    showLb() {
      var p = this.lbPos;
      this.lbImgs.forEach(function (img, k) {
        img.hidden = k !== p;
        img.classList.remove('is-zoomed');
        if (k === p) img.loading = 'eager';
      });
    }
  }
  if (!customElements.get('wt-gallery')) customElements.define('wt-gallery', WtGallery);

  /* ---------- Buy box ---------- */
  class WtBuyBox extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-wt-variants]').textContent);
        this.cfg = JSON.parse(this.querySelector('[data-wt-config]').textContent);
      } catch (e) { console.warn('[Welltoe] buy box data', e); return; }
      this.form = this.querySelector('[data-wt-form]');
      this.variantInput = this.querySelector('[data-wt-variant-input]');
      this.qtyInput = this.querySelector('[data-wt-qty-input]');
      this.btn = this.querySelector('[data-wt-atc]');
      this.errorEl = this.querySelector('[data-wt-error]');
      this.picker = this.querySelector('[data-wt-picker]');
      this.rows = this.picker ? Array.prototype.slice.call(this.picker.querySelectorAll('[data-wt-pair]')) : [];
      this.touched = [];
      var self = this;
      this.addEventListener('change', function (e) {
        var name = e.target.name || '';
        if (name.indexOf('wt-tier-') === 0) self.update();
        else if (name.indexOf('wt-opt-') === 0) self.update(true);
        else if (name.indexOf('wt-pair-') === 0 || e.target.hasAttribute('data-wt-pair-select')) self.onPair(e.target);
      });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
      this.update();
    }
    tier() {
      var r = this.querySelector('input[name^="wt-tier-"]:checked');
      return r ? r.value : '1';
    }
    byId(id) {
      id = Number(id);
      return this.variants.find(function (v) { return v.id === id; }) || null;
    }
    /* Variant chosen on pair row i (per-pair color mode). */
    rowVariant(i) {
      var row = this.rows[i];
      if (!row) return null;
      var sel = row.querySelector('[data-wt-pair-select]');
      var input = sel || row.querySelector('input:checked');
      return input ? this.byId(input.value) : null;
    }
    setRow(i, id) {
      var row = this.rows[i];
      if (!row) return;
      var sel = row.querySelector('[data-wt-pair-select]');
      if (sel) { sel.value = String(id); return; }
      var input = row.querySelector('input[value="' + id + '"]');
      if (input && !input.disabled) input.checked = true;
    }
    /* List of variants for the first n pairs. Falls back to pair 1 so prices never break. */
    picks(n) {
      var out = [], first = this.rowVariant(0);
      for (var i = 0; i < n; i++) out.push(this.rowVariant(i) || first);
      return out;
    }
    variant() {
      if (this.picker) return this.rowVariant(0);
      var sets = Array.prototype.slice.call(this.querySelectorAll('[data-wt-option]'));
      if (!sets.length) return this.variants[0];
      var chosen = sets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return chosen[i] === null || o === chosen[i]; });
      }) || null;
    }
    onPair(target) {
      var row = target.closest('[data-wt-pair]');
      var i = Number(row.dataset.wtPair);
      var v = this.rowVariant(i);
      /* Each pair keeps its own color: changing one pair never changes the others. */
      this.update();
      if (v) document.dispatchEvent(new CustomEvent('wt:variant', { detail: v }));
    }
    /* Totals for a tier: paid pairs are charged, every pair counts toward the compare-at value. */
    tierTotals(cfg) {
      var list = this.picker ? this.picks(cfg.qty) : null;
      var v = this.variant();
      if (!list) {
        if (!v) return null;
        return { total: v.price * cfg.paid, compare: v.compare * cfg.qty, available: v.available };
      }
      var total = 0, compare = 0, available = true;
      list.forEach(function (pv, i) {
        if (!pv) { available = false; return; }
        if (i < cfg.paid) total += pv.price;
        compare += pv.compare;
        if (!pv.available) available = false;
      });
      if (!list[0]) return null;
      return { total: total, compare: compare, available: available };
    }
    update(variantChanged) {
      var v = this.variant();
      var t = this.tier();
      var tiers = this.cfg.tiers;
      var fmt = this.cfg.moneyFormat;
      var self = this;

      this.querySelectorAll('[data-wt-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-wt-option-value]');
        if (out && c) out.textContent = c.value;
      });

      var cfg = tiers[t];
      if (this.picker) {
        this.rows.forEach(function (row, i) {
          row.hidden = i >= cfg.qty;
          var free = row.querySelector('[data-wt-pair-free]');
          if (free) free.hidden = i < cfg.paid;
          var name = row.querySelector('[data-wt-pair-name]');
          var rv = self.rowVariant(i);
          if (name && rv) name.textContent = rv.title;
        });
        var hint = this.picker.querySelector('[data-wt-pairs-hint]');
        if (hint) hint.textContent = cfg.qty > 1 ? 'Mix and match. Free pairs too.' : 'Choose your color.';
      }

      this.querySelectorAll('.wt-tier').forEach(function (card) {
        var k = card.dataset.tier;
        var tc = tiers[k];
        card.classList.toggle('is-selected', k === t);
        var tt = self.tierTotals(tc);
        if (!tt) return;
        var pct = tt.compare > tt.total ? Math.round((tt.compare - tt.total) / tt.compare * 100) : 0;
        var pEl = card.querySelector('[data-tier-price]');
        var cEl = card.querySelector('[data-tier-compare]');
        var perEl = card.querySelector('[data-tier-per]');
        var pctEl = card.querySelector('[data-tier-pct]');
        if (pEl) setMoney(pEl, formatMoney(tt.total, fmt));
        if (cEl) { setMoney(cEl, formatMoney(tt.compare, fmt)); cEl.hidden = pct === 0; }
        if (perEl) setMoney(perEl, formatMoney(Math.round(tt.total / tc.qty), fmt));
        if (pctEl) { pctEl.textContent = 'SAVE ' + pct + '%'; pctEl.hidden = pct === 0; }
      });

      var totals = this.tierTotals(cfg) || { total: 0, compare: 0, available: false };
      var available = !!(v && totals.available);
      if (v) this.variantInput.value = v.id;
      this.qtyInput.value = cfg.qty;
      this.btn.disabled = !available;
      var label = this.btn.querySelector('[data-wt-atc-label]');
      if (!this.defaultLabel) this.defaultLabel = label.textContent;
      label.textContent = !v ? 'Unavailable' : (available ? this.defaultLabel : 'Sold out');
      var total = totals.total;
      var compare = totals.compare;
      setMoney(this.btn.querySelector('[data-wt-atc-price]'), v ? formatMoney(total, fmt) : '');

      this.state = {
        tier: t, variant: v, total: total, compare: compare,
        pct: compare > total ? Math.round((compare - total) / compare * 100) : 0,
        title: (this.querySelector('.wt-tier.is-selected .wt-tier__title') || {}).textContent || '',
        price: formatMoney(total, fmt), comparePrice: formatMoney(compare, fmt), available: available
      };
      this.dispatchEvent(new CustomEvent('wt:change', { bubbles: true, detail: this.state }));
      if (variantChanged && v) {
        document.dispatchEvent(new CustomEvent('wt:variant', { detail: v }));
        document.querySelectorAll('wt-buy-box').forEach(function (other) {
          if (other !== self && other.syncVariant) other.syncVariant(v);
        });
      }
    }
    syncVariant(v) {
      if (this.picker) return;
      var sets = this.querySelectorAll('[data-wt-option]');
      sets.forEach(function (fs, i) {
        var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (inp) { return inp.value === v.options[i]; });
        if (input) input.checked = true;
      });
      this.update(false);
    }
    /* Cart lines for the selected tier: paid pairs grouped by color, free pairs as separate
       lines marked _wt_free so the cart keeps the colors the shopper picked. */
    lineItems() {
      var cfg = this.cfg.tiers[this.tier()];
      if (!this.picker) {
        var v = this.variant();
        return v ? [{ id: v.id, quantity: cfg.paid }] : [];
      }
      var paid = {}, free = {}, order = [];
      this.picks(cfg.qty).forEach(function (pv, i) {
        if (!pv) return;
        var bucket = i < cfg.paid ? paid : free;
        var key = (i < cfg.paid ? 'p' : 'f') + pv.id;
        if (!bucket[pv.id]) { bucket[pv.id] = 0; order.push(key); }
        bucket[pv.id]++;
      });
      return order.map(function (key) {
        var id = Number(key.slice(1));
        if (key[0] === 'p') return { id: id, quantity: paid[id] };
        var gc = readGiftConfig() || {};
        var fid = (gc.freeProductId && gc.freeMap && gc.freeMap[String(id)]) || id;
        return { id: fid, quantity: free[id], properties: { _wt_free: 'Free pair' } };
      });
    }
    submit() {
      var v = this.variant();
      if (!v || this.btn.disabled || this.btn.classList.contains('is-loading')) return;
      var items = this.lineItems();
      if (!items.length) return;
      var self = this;
      this.btn.classList.add('is-loading');
      this.btn.setAttribute('aria-busy', 'true');
      if (this.errorEl) this.errorEl.hidden = true;
      addToCart(items)
        .catch(function (err) {
          if (self.errorEl) {
            self.errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
            self.errorEl.hidden = false;
          }
        })
        .finally(function () {
          self.btn.classList.remove('is-loading');
          self.btn.removeAttribute('aria-busy');
        });
    }
  }
  if (!customElements.get('wt-buy-box')) customElements.define('wt-buy-box', WtBuyBox);

  /* ---------- Hero headline price + sticky bar ---------- */
  function initHero(hero) {
    var box = hero.querySelector('wt-buy-box');
    if (!box) return;
    var hPrice = hero.querySelector('[data-wt-h-price]');
    var hCompare = hero.querySelector('[data-wt-h-compare]');
    var hPct = hero.querySelector('[data-wt-h-pct]');
    var sticky = hero.querySelector('[data-wt-sticky]');
    var sTier = hero.querySelector('[data-wt-s-tier]');
    var sPrice = hero.querySelector('[data-wt-s-price]');
    var sBtn = hero.querySelector('[data-wt-sticky-btn]');

    box.addEventListener('wt:change', function (e) {
      var s = e.detail;
      if (hPrice) setMoney(hPrice, s.price);
      if (hCompare) { setMoney(hCompare, s.comparePrice); hCompare.hidden = !s.pct; }
      if (hPct) { hPct.textContent = 'SAVE ' + s.pct + '%'; hPct.hidden = !s.pct; }
      if (sTier) sTier.textContent = s.title.trim();
      if (sPrice) setMoney(sPrice, s.price);
      if (sBtn) sBtn.disabled = !s.available;
    });
    if (box.state) box.dispatchEvent(new CustomEvent('wt:change', { detail: box.state }));

    if (!sticky) return;
    document.body.classList.add('wt-has-sticky');
    sBtn.addEventListener('click', function () { box.submit(); });
    var atc = box.querySelector('[data-wt-atc]');
    var mainVisible = true;
    var otherVisible = false;
    function toggle() {
      var show = !mainVisible && !otherVisible && atc.getBoundingClientRect().top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      sBtn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('wt-sticky-on', show);
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting; toggle();
    }).observe(atc);
    var others = Array.prototype.filter.call(document.querySelectorAll('wt-buy-box'), function (b) { return b !== box; });
    if (others.length) {
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        otherVisible = visible.size > 0; toggle();
      });
      others.forEach(function (b) { io.observe(b); });
    }
    window.addEventListener('scroll', toggle, { passive: true });
  }

  /* ---------- Cart drawer extras ---------- */
  /* One-card cart: +/- paid pairs and remove all pairs. Free pairs and gifts follow via syncGifts(). */
  function afterCardChange(card) {
    return syncGifts()
      .then(function () { return refreshSections(); })
      .then(renderDrawer)
      .catch(function (err) { alert(err.message); if (card) card.classList.remove('is-loading'); });
  }
  function onPairsCard(e) {
    var step = e.target.closest('[data-wt-pairs-step]');
    var clear = e.target.closest('[data-wt-pairs-clear]');
    if (!step && !clear) return false;
    e.preventDefault();
    var card = e.target.closest('[data-wt-pcard]');
    if (card) card.classList.add('is-loading');
    var req;
    if (clear) {
      var updates = {};
      clear.dataset.keys.split(',').filter(Boolean).forEach(function (k) { updates[k] = 0; });
      req = jsonFetch('cart/update.js', { updates: updates });
    } else if (Number(step.dataset.wtPairsStep) > 0) {
      req = jsonFetch('cart/add.js', { items: [{ id: Number(step.dataset.variant), quantity: 1 }] });
    } else {
      req = jsonFetch('cart/change.js', { id: step.dataset.key, quantity: Math.max(0, Number(step.dataset.qty) - 1) });
    }
    req.then(function () { return afterCardChange(card); })
      .catch(function (err) { alert(err.message); if (card) card.classList.remove('is-loading'); });
    return true;
  }

  function onDrawerClick(e) {
    if (onPairsCard(e)) return;
    var up = e.target.closest('[data-wt-upgrade]');
    if (up) {
      e.preventDefault();
      up.classList.add('is-loading');
      jsonFetch('cart/change.js', { id: up.dataset.key, quantity: Number(up.dataset.qty), sections: sectionIds() })
        .then(function (res) { return syncGifts().then(function (synced) {
          if (synced === true) return refreshSections().then(renderDrawer);
          renderDrawer(synced || res.sections);
        }); })
        .catch(function (err) { alert(err.message); })
        .finally(function () { up.classList.remove('is-loading'); });
      return;
    }
    var add = e.target.closest('[data-wt-quick-add]');
    if (add) {
      e.preventDefault();
      add.classList.add('is-loading');
      addToCart([{ id: Number(add.dataset.wtQuickAdd), quantity: 1 }])
        .catch(function (err) { alert(err.message); })
        .finally(function () { add.classList.remove('is-loading'); });
    }
  }

  /* Change the color of one pair on a cart line (dropdown): take 1 off this line, add 1 of the new color.
     Free pairs keep their _wt_free mark so they stay free. */
  function onRecolorChange(e) {
    var sel = e.target.closest && e.target.closest('[data-wt-recolor-select]');
    if (!sel) return;
    var vid = Number(sel.value);
    if (!vid || vid === Number(sel.dataset.current)) return;
    var group = sel.closest('.wt-recolor');
    var onCartPage = !!sel.closest('#main-cart-items, cart-items');
    if (group) group.classList.add('is-loading');
    sel.disabled = true;
    notePairRecolor(sel, vid);
    var qty = Number(sel.dataset.qty) || 1;
    var line = { id: vid, quantity: 1 };
    if (sel.dataset.free === 'true') line.properties = { _wt_free: 'Free pair' };
    jsonFetch('cart/change.js', { id: sel.dataset.key, quantity: qty - 1 })
      .then(function () { return jsonFetch('cart/add.js', { items: [line], sections: sectionIds() }); })
      .then(function (res) { return syncGifts().then(function (synced) {
        /* On the full cart page, reload so the page shows the new lines. */
        if (onCartPage) { window.location.reload(); return; }
        if (synced === true) return refreshSections().then(renderDrawer);
        renderDrawer(synced || res.sections);
      }); })
      .catch(function (err) {
        alert(err.message);
        if (onCartPage) window.location.reload();
        else refreshSections().then(renderDrawer);
      })
      .finally(function () {
        if (group) group.classList.remove('is-loading');
        sel.disabled = false;
      });
  }

  function subscribeCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (evt && evt.source === 'welltoe') return;
      /* Shopper removed the last item with Dawn's own buttons: close the drawer. */
      if (evt && evt.cartData && evt.cartData.item_count === 0 && !document.getElementById('main-cart-items')) {
        closeDrawerIfEmpty(0);
        return;
      }
      syncGifts().then(function (synced) {
        if (!synced) return;
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
        } else if (document.querySelector('cart-drawer')) {
          if (synced === true) refreshSections().then(renderDrawer); else renderDrawer(synced);
        }
      });
    });
  }

  /* ---------- Reviews wall filter + search ---------- */
  function initReviews(wall) {
    var cards = Array.prototype.slice.call(wall.querySelectorAll('[data-review]'));
    var search = wall.querySelector('[data-wt-review-search]');
    var chips = wall.querySelectorAll('[data-wt-review-filter]');
    var empty = wall.querySelector('[data-wt-review-empty]');
    var more = wall.querySelector('[data-wt-review-more]');
    var pageSize = Number(wall.dataset.pageSize || 6);
    var limit = pageSize;
    var filter = 'all';
    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0, matched = 0;
      cards.forEach(function (c) {
        var ok = true;
        if (filter === 'photos') ok = c.dataset.hasPhoto === 'true';
        else if (filter !== 'all') ok = c.dataset.rating === filter;
        if (ok && q) ok = c.textContent.toLowerCase().indexOf(q) > -1;
        if (ok) matched++;
        var visible = ok && matched <= limit;
        c.hidden = !visible;
        if (visible) shown++;
      });
      if (empty) empty.hidden = matched > 0;
      if (more) more.hidden = matched <= limit;
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.dataset.wtReviewFilter;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        limit = pageSize; apply();
      });
    });
    if (search) search.addEventListener('input', function () { limit = pageSize; apply(); });
    if (more) more.addEventListener('click', function () { limit += pageSize; apply(); });
    apply();
  }

  /* ---------- Misc ---------- */
  function initAccordionLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-wt-open-accordion]');
      if (!link) return;
      var target = document.getElementById(link.dataset.wtOpenAccordion);
      if (!target) return;
      e.preventDefault();
      target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function initTrackForm(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = form.querySelector('input').value.trim();
      if (!n) return;
      window.open(form.dataset.url.replace('{number}', encodeURIComponent(n)), '_blank', 'noopener');
    });
  }

  function init() {
    document.querySelectorAll('[data-wt-hero]').forEach(initHero);
    document.querySelectorAll('[data-wt-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-wt-track-form]').forEach(initTrackForm);
    initAccordionLinks();
    document.addEventListener('click', onDrawerClick);
    document.addEventListener('change', onRecolorChange);
    subscribeCart();
    applyPairOrder();
    watchPairGrid();
    if (document.getElementById('main-cart-items')) {
      syncGifts().then(function (s) { if (s) window.location.reload(); });
    }
  }

  window.Welltoe = { formatMoney: formatMoney, setMoney: setMoney, syncGifts: syncGifts, addToCart: addToCart, freeFor: freeFor };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-wt-hero]').forEach(initHero);
    e.target.querySelectorAll('[data-wt-reviews]').forEach(initReviews);
  });
})();
